import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useCallback, useState } from 'react';
import useInterval from "./useInterval";
var links = {
  facebook: function facebook(url) {
    return "https://www.facebook.com/sharer/sharer.php?u=".concat(encodeURIComponent(url), "&amp;src=sdkpreparse");
  },
  linkedin: function linkedin(url) {
    return "https://www.linkedin.com/shareArticle?mini=true&url=".concat(encodeURIComponent(url));
  },
  twitter: function twitter(url, hashtags, text) {
    return "http://twitter.com/share?url=".concat(encodeURIComponent(url)).concat(hashtags !== null && hashtags !== void 0 && hashtags.length ? "&hashtags=".concat(hashtags.join(',')) : '').concat(text ? "&text=".concat(encodeURIComponent(text)) : '');
  }
};
var config = {
  height: 500,
  width: 700,
  location: 'no',
  toolbar: 'no',
  status: 'no',
  directories: 'no',
  menubar: 'no',
  scrollbars: 'yes',
  resizable: 'no',
  centerscreen: 'yes',
  chrome: 'yes'
};
export default function useSocialNetworkShare(_ref) {
  var to = _ref.to,
    url = _ref.url,
    hashtags = _ref.hashtags,
    text = _ref.text;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var windowRef = useRef(null);
  // Stop the interval while the window is not open;
  var interval = isOpen ? 1000 : null;
  var handler = useCallback(function (customUrl) {
    if (!customUrl && !to && !url) {
      throw new Error('If you dont pass a customUrl you must send "to" and "url" to useShare');
    }
    windowRef.current = window.open(customUrl || links[to](url, hashtags, text), '', Object.keys(config).map(function (key) {
      return "".concat(key, "=").concat(config[key]);
    }).join(', '));
    setIsOpen(windowRef.current !== null);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [to, url]);
  useInterval(function () {
    var _windowRef$current;
    return setIsOpen(((_windowRef$current = windowRef.current) === null || _windowRef$current === void 0 ? void 0 : _windowRef$current.closed) === false);
  }, interval);
  return [handler, {
    isOpen: isOpen,
    ref: windowRef
  }];
}